// extracted by mini-css-extract-plugin
module.exports = {"container":"FetchContainer_container__NR0xs"};